/**
 * @lodex-pro/web-portal/hooks/useDisposalRegisterMutation — TanStack Query mutation
 * hook wrapping publicApi.disposalRegister (DEC-160).
 *
 * Mirrors useOperatorRegisterMutation. Uses bare `useMutation` from
 * @tanstack/react-query — NOT `useApiMutation` from @lodex-pro/web-shared which
 * uses authedFetch. Public endpoints do not need Amplify auth headers.
 */

import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import { disposalRegister, type PublicApiError } from '../public/publicApi';
import type {
  DisposalRegistrationRequest,
  DisposalRegistrationResponse,
} from '@lodex-pro/shared/validation/disposal-portal';

export function useDisposalRegisterMutation(): UseMutationResult<
  DisposalRegistrationResponse,
  PublicApiError,
  DisposalRegistrationRequest
> {
  return useMutation<DisposalRegistrationResponse, PublicApiError, DisposalRegistrationRequest>({
    mutationFn: (body) => disposalRegister(body),
  });
}
